// extracted by mini-css-extract-plugin
module.exports = {"timeNow":"CurrentTime-module--timeNow--1D0Fg","currentEmotion":"CurrentTime-module--currentEmotion--2LEV9"};